import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuiBrandedLoader } from '@avalara/skylab-sdk/react';
import { setCurrentOfferPage } from '../../../store/offer';
import { selectState } from '../../../selectors';
import { pollForSoldOffer } from '../../../lib/side-effects/polling';
import NeedAssistance from '../need-assistance-afs';
import { Pages } from '../../../../shared/types/offers';
const AvalaraForShopifySettingUp = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { account: { accountId }, system: { error }, } = useSelector(selectState);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.SettingUp));
        if (!error)
            dispatch(pollForSoldOffer(accountId, history));
    }, []);
    if (error)
        return null;
    return (React.createElement("div", { className: "flex flex-dir-col align-items-center margin-top-xl", "data-ref": "avalara-for-shopify.setting-up" },
        React.createElement(AuiBrandedLoader, null),
        React.createElement(NeedAssistance, null)));
};
export default AvalaraForShopifySettingUp;
